import { render, staticRenderFns } from "./transform-goods-list.vue?vue&type=template&id=18b52167"
import script from "./transform-goods-list.vue?vue&type=script&lang=js"
export * from "./transform-goods-list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports